import wrapWithProvider from "./wrap-with-provider";
import "./src/styles/styles.scss";
export const wrapRootElement = wrapWithProvider;
